module.exports = __webpack_public_path__ + "media/fundraising_sim/fun_img02-60c3353f.png";